import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RootState } from 'store'
import { DashboardCard } from 'styling/GlobalStyles'
import { groputDashboardItems } from 'utils/helpers'
import { IWidget } from 'types/dashboard.interface'
import { WidgetHeader, WidgetTitle } from 'pages/HrDashboard/Widgets/widgetParts.styled'
import { WidgetBody } from 'pages/HrDashboard/hrLayout.styled'
import { DistributionDonut } from './DistributionDonut'
import { toDonutRows } from './statusMeta'

export const TasksWidget = ({ modalOpen }: IWidget) => {
  const navigate = useNavigate()
  const { taskStatuses } = useSelector((state: RootState) => state.dashboard)
  const rows = toDonutRows(groputDashboardItems(taskStatuses))

  return (
    <DashboardCard
      width='1fr'
      onClick={() => !modalOpen && navigate('/dashboard/tasks')}
      style={{ height: '100%', cursor: modalOpen ? 'grab' : 'pointer' }}
    >
      <WidgetHeader>
        <WidgetTitle>Tasks</WidgetTitle>
      </WidgetHeader>
      <WidgetBody>
        <DistributionDonut rows={rows} centerLabel='tasks' />
      </WidgetBody>
    </DashboardCard>
  )
}
